'use strict';
var $ = require('jquery');
var _ = require('lodash');
var FLOW_NAME = require('../constants').AppConstants.FLOW_NAME;

module.exports = {
    /**
     * Convert new line to <br> excluding the last new line charactor.
     * @param  {String} str
     * @return {String} a new string with new lines converted to <br>
     */
    nl2br: function (str) {
        return str.replace(/(\n(?!$))+/g, '</br/>');
    },

    /**
     * Format a given zip code string to xxxxx (5 digits) or xxxxx-xxxx (9 digits).
     * If the string has more than 9 digits, it'll be clipped accordingly.
     * To be used as part of zip code input formatter.
     */
    formatUSZipCode: function (zipCode) {
        zipCode = zipCode.replace('-', '');

        if (zipCode.length <= 5) {
            return zipCode;
        } else {
            return zipCode.substring(0, 5) + '-' + zipCode.substring(5, 9);
        }
    },

    /**
     * Format a given expire date string to MM/YY.
     * To be used as part of expire date input formatter.
     */
    formatExpirationDate: function (expireDate) {
        expireDate = expireDate.replace('/', '');

        if (expireDate.length <= 2) {
            return expireDate;
        } else {
            return expireDate.substring(0, 2) + '/' + expireDate.substring(2, 4);
        }
    },

    /**
     * Format a given Date of Birth string to MM/DD/YYYY.
     * To be used as part of Date of Birth input formatter.
     */
    formatDOBDate: function (dobDate) {
        if (!dobDate || dobDate.length <= 2) {
            return dobDate;
        } else if (dobDate.length <= 4) {
            return dobDate.substring(0, 2) + '/' + dobDate.substring(2, 4);
        } else if (dobDate.length <= 8) {
            return dobDate.substring(0, 2) + '/' + dobDate.substring(2, 4) + '/' + dobDate.substring(4, 8);
        } else {
            return dobDate;
        }
    },

    /**
     * Transform DOB from MMDDYYYY (user input) to YYYY-MM-DD (API format).
     */
    formatDobApi: function (dob) {
        var matches = dob.match(/^(\d{2})(\d{2})(\d{4})$/); // [MMDDYYYY, MM, DD, YYYY]
        return [matches[3], matches[1], matches[2]].join('-');
    },

    unformatDOBDate: function (formatted) {
        // substring is required to prevent users from typing too many digits.
        return formatted && formatted.replace(/[^0-9]/g, '').substring(0, 8);
    },

    /**
     * Format a given Social Security Number string to XXX-XX-XXXX.
     * To be used as part of Social Security Number input formatter.
     */
    formatSSN: function (ssnValue) {
        if (!ssnValue || ssnValue.length <= 3) {
            return ssnValue;
        } else if (ssnValue.length <= 5) {
            return ssnValue.substring(0, 3) + '-' + ssnValue.substring(3, 5);
        } else if (ssnValue.length <= 9) {
            return ssnValue.substring(0, 3) + '-' + ssnValue.substring(3, 5) + '-' + ssnValue.substring(5, 9);
        } else {
            return ssnValue;
        }
    },

    unformatSSN: function (formatted) {
        return formatted && formatted.replace(/-/g, '');
    },

    getPreservedState: function (resData) {
        var retryCount = 0;
        var errorMsgConstant = null;
        var code, values;
        if (resData && resData.eligibility_details) {
            code = resData.eligibility_details.eligibility_status;
            values = this.getEligibilityDetails(resData);
        }
        if (resData && resData.result_details) {
            code = _.get(resData, 'result_details.code');
            values = _.get(resData, 'result_details.values[0]');
        }

        // For all DENY eligibility_status - show "Go to Summary" error page
        // TODO: Array and string comparison, do not fix the equality
        if (code == 'DENY') { // eslint-disable-line eqeqeq
            errorMsgConstant = 'DENY';
            // Get eligibility_details - show "Go to Summary" error page
            if (values == 'BLOCK_REASON_RISKY_NEW_DC_USER') { // eslint-disable-line eqeqeq
                errorMsgConstant = 'BLOCK_REASON_RISKY_NEW_DC_USER';
            }
            retryCount = 1;
        }

        return {
            retryCount: retryCount,
            errorMsgConstant: errorMsgConstant
        };
    },

    getEligibilityDetails: function (response) {
        var eligibilityDetails = response.eligibility_details;
        if (eligibilityDetails) {
            var reasonCode = null;
            if (eligibilityDetails.details) {
                reasonCode = eligibilityDetails.details.filter(
                                function (info) {
                                    return !!info.reason;
                                }
                             ).map(
                                function (info) {
                                    return info.reason;
                                }
                            );
            }
            return reasonCode;
        }
    },

    isOnBrowser: function () {
        return (typeof window !== 'undefined') && window.document;
    },

    isDebug: function () {
        if (this.isOnBrowser() &&
            $('.application-root').data('fields') !== null &&
            $('.application-root').data('fields').debug) {
            return true;
        }
        return false;
    },

    formatProductNames: function (productObj, andLabel) {
        var onlyPayProduct = _.filter(productObj, function (o) { return o.legal_product_name !== 'PayPal Cash Card' && o.legal_product_name !== null; });
        var legalProductNameObj = _.map(onlyPayProduct, 'legal_product_name');
        var dynamicProductName = '';
        for (var i = 0; i < legalProductNameObj.length; i++) {
            var lastOne = legalProductNameObj.length - 1;
            if (i === 0) {
                dynamicProductName = legalProductNameObj[i];
            } else if (i === lastOne) {
                dynamicProductName += andLabel + ' ' + legalProductNameObj[i];
            } else {
                dynamicProductName += ', ' + legalProductNameObj[i];
            }
        }
        return dynamicProductName;
    },

    getPageId: function (pageIdSuffix, calledFrom) {
        var prefix;
        switch (calledFrom) {
            case FLOW_NAME.DAMAGED_CARD:
                prefix = 'damagedCard';
                break;
            case FLOW_NAME.REPORT_LOST_CARD:
                prefix = 'reportCard';
                break;
            case FLOW_NAME.CHANGE_BILLING_ADDRESS:
                prefix = 'changeBilling';
                break;
            case FLOW_NAME.UPGRADE_BUNDLE:
                prefix = 'upgradeBundle';
                break;
            case FLOW_NAME.REPLACE_CARD:
                prefix = 'replaceCard';
        }

        if (!prefix && this.isDebug() && console.error) {
            console.error('Unable to format FPTI page ID, suffix: ', pageIdSuffix,
                ', calledFrom:', calledFrom);
        }

        return prefix + pageIdSuffix;
    },

    formatAJAXErrorMessage: function (msg, res) {
        if (res && res.status) {
            return msg + ' (' + res.status + ' - ' + res.statusText + ')';
        }
        return msg;
    },

    triggerVeniceCallback: function (veniceHandlerName) {
        if (window.venice && window.venice[veniceHandlerName]) {
            window.venice[veniceHandlerName]();
            return true;
        }

        return false;
    },

    getPreferredShippingAddress: function (cardInfo, billingAddresses) {
        var shippingAddressId = cardInfo.shipping_address_id;
        return billingAddresses.filter(function (address) {
            return address.id === shippingAddressId;
        })[0];
    },

    getFundingSourceName: function (fundingSource) {
        const { id, issuer_name: issuerName, classification } = fundingSource;
        if (id.includes('CC-')) {
            return classification;
        }
        if (id.includes('BA-')) {
            return issuerName;
        }
        return null;
    }

};



// WEBPACK FOOTER //
// ./public/js/utils/index.js